import React, { useEffect, useState } from "react";
import { TiHome } from "react-icons/ti";
import {
  Link,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { getFetcher, postFetcher } from "../../../api/fetchers";
import { endpoints } from "../../../api/endpoints";
import ProductCart from "../../components/ProductCart";
import Spinner from "../../components/spinner/Spinner";
import { BsSnow } from "react-icons/bs";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import { useLanguage } from "../../context/LanguageContext";
import { useUser } from "../../context/UserContext";

const ProductCategories: React.FC = () => {
  const { t, language } = useLanguage();
  const { catId } = useParams();
  const location = useLocation();
  const { user } = useUser();
  const queryParams = new URLSearchParams(location.search);
  const subCatName = queryParams.get("subCatName");
  const isMost = queryParams.get("isMost");
  const [searchParams] = useSearchParams();
  const catName = searchParams.get("catName");
  const main = searchParams.get("main");

  const navigate = useNavigate();

  const [categoryProducts, setCategoryProducts] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [categories, setCategories] = useState<any>([]);
  const [filteredProducts, setFilteredProducts] = useState<any>([]);
  const [userBusinessPackage, setUserBusinessPackage] = useState<any>();

  const [prices] = useState([
    { value: t("productCategories", "s1"), min: 0, max: Infinity },
    { value: t("productCategories", "s2"), min: 0, max: 200 },
    { value: t("productCategories", "s3"), min: 200, max: 500 },
    { value: t("productCategories", "s4"), min: 500, max: 1500 },
    { value: t("productCategories", "s5"), min: 1500, max: 4000 },
    { value: t("productCategories", "s6"), min: 4000, max: 5000 },
  ]);
  const [activeCategory, setActiveCategory] = useState<any>();
  const [activePrice, setActivePrice] = useState<any>();
  const [progress, setProgress] = useState(0);
  const [offset, setOffset] = useState(0);
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");

  const maxLimit = 5000;

  const handleApply = () => {
    const min = parseInt(minPrice) || 0;
    const max = parseInt(maxPrice) || maxLimit;

    if (min >= 0 && max <= maxLimit && min <= max) {
      setActivePrice(null);
      const calculatedProgress = ((max - min) / maxLimit) * 100;
      const calculatedOffset = (min / maxLimit) * 100;

      setProgress(calculatedProgress);
      setOffset(calculatedOffset);

      const filtered = categoryProducts.filter((product: any) => {
        return product.price >= min && product.price <= max;
      });

      if (filtered.length === 0) {
        toast.info(`${min}TL - ${max}TL aralığında ürün bulunmamaktadır.`);
      }

      setFilteredProducts(filtered);
    } else {
      toast.error("Lütfen geçerli bir fiyat aralığı giriniz");
      setProgress(0);
      setOffset(0);
    }
  };

  const handleMinPriceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMinPrice(e.target.value);
  };

  const handleMaxPriceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMaxPrice(e.target.value);
  };

  // useEffect(() => {
  //   const fetchProducts = async () => {
  //     setLoading(true);
  //     try {
  //       if (catName) {
  //         const response = await getFetcher(
  //           endpoints.products.getProductsByMainCategory.replace(
  //             "{id}",
  //             catId || ""
  //           )
  //         );
  //         if (response?.result) {
  //           setCategoryProducts(response.products);
  //           setFilteredProducts([]);
  //         }
  //       } else if (isMost === "true") {
  //         const response = await getFetcher(
  //           endpoints.products.getProductsByMainCategory.replace(
  //             "{id}",
  //             catId || ""
  //           )
  //         );
  //         if (response?.result) {
  //           setCategoryProducts(response.products);
  //           setFilteredProducts([]);
  //         }
  //       } else if (catId) {
  //         const productsResponse = await postFetcher(
  //           endpoints.products.productsSubCategoryId,
  //           {
  //             arg: {
  //               subCategoryId: catId,
  //               pageNumber: 0,
  //             },
  //           }
  //         );
  //         if (productsResponse.result) {
  //           setCategoryProducts(productsResponse.products);
  //           setFilteredProducts([]);
  //         }
  //       } else if (main) {
  //         if (catId) {
  //           getProductCategory(catId);
  //         } else {
  //           console.warn("catId değeri geçersiz, API çağrısı yapılmadı.");
  //         }
  //       }
  //     } catch (error) {
  //       console.error("Error fetching products:", error);
  //       setCategoryProducts([]);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchProducts();
  // }, [catId, catName, main]);

  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);
      try {
        if (catName) {
          // catName varsa buna özel API isteği
          const response = await getFetcher(
            endpoints.products.getProductsByMainCategory.replace(
              "{id}",
              catId || ""
            )
          );
          if (response?.result) {
            setCategoryProducts(response.products);
            setFilteredProducts([]);
          }
        } else if (isMost === "true") {
          // En çok satan ürünleri getir
          const response = await getFetcher(
            endpoints.products.getProductsByMainCategory.replace(
              "{id}",
              catId || ""
            )
          );
          if (response?.result) {
            setCategoryProducts(response.products);
            setFilteredProducts([]);
          }
        } else if (catId && !main) {
          // Eğer sadece catId varsa ve main yoksa bu istek yapılmalı
          const productsResponse = await postFetcher(
            endpoints.products.productsSubCategoryId,
            {
              arg: {
                subCategoryId: catId,
                pageNumber: 0,
              },
            }
          );
          if (productsResponse.result) {
            setCategoryProducts(productsResponse.products);
            setFilteredProducts([]);
          }
        } else if (main && catId) {
          // Eğer sadece main varsa ve catId yoksa bu istek yapılmalı
          getProductCategory(catId);
        }
      } catch (error) {
        console.error("Error fetching products:", error);
        setCategoryProducts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [catId, catName, main, isMost]);

  useEffect(() => {
    const fetchCategories = async () => {
      setLoading(true);
      try {
        const response = await getFetcher(
          endpoints.products.getProductCategory
        );
        if (response) {
          setCategories(response?.productCategories);
          setTimeout(() => {
            setLoading(false);
          }, 500);
        } else {
          setCategories([]);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    setActiveCategory(null);
  }, [subCatName]);

  const getProductCategory = async (categoryId?: string) => {
    setLoading(true);
    try {
      const response = await getFetcher(
        endpoints.products.getProductsByMainCategory.replace(
          "{id}",
          categoryId || (catName ? catId : activeCategory?.id)
        )
      );
      if (response?.result) {
        setCategoryProducts(response.products);
        setFilteredProducts([]);
      } else {
        setCategoryProducts([]);
      }
    } catch (error) {
      console.log(error);
      setCategoryProducts([]);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeCategory = (category: any) => {
    setActiveCategory(category);
    setFilteredProducts([]);
    setActivePrice(null);
    setMinPrice("");
    setMaxPrice("");

    getProductCategory(category.id);
  };

  const handlePriceChange = (price: any) => {
    setActivePrice(price);
    setMinPrice("");
    setMaxPrice("");

    if (price.value === "Tüm Ürünler") {
      setFilteredProducts(categoryProducts);
      return;
    }

    const filtered = categoryProducts.filter(
      (product: any) => product.price >= price.min && product.price <= price.max
    );
    setFilteredProducts(filtered);
  };

  const fetchBusinessPackageData = async () => {
    if (user) {
      try {
        const businessPackage = await getFetcher(
          endpoints.user.getBusinessPackageById.replace(
            "{id}",
            user.businessPackageId
          )
        );
        if (businessPackage.result) {
          setUserBusinessPackage(businessPackage.businessPackage);
        }
      } catch (error) {
        console.error("Error fetching business package:", error);
      } finally {
        console.log("first");
      }
    } else {
      console.log("err");
    }
  };

  useEffect(() => {
    fetchBusinessPackageData();
  }, [user]);

  return (
    <div className=" flex flex-col">
      {/* <Header />
      <Navbar /> */}
      <ToastContainer />
      {/* navigation */}
      <div className=" min-h-[70px] flex items-center justify-start bg-[#F2F4F5] px-0 lg:px-32 2xl:px-48 gap-x-2 select-none relative mb-4">
        <div
          className=" flex  items-center gap-x-1 text-[#5F6C72] font-poppins text-[14px] cursor-pointer hover:underline transition-all"
          onClick={() => navigate("/")}
        >
          <div>
            <TiHome className=" mb-[2px]" />
          </div>
          <Link to="/">{t("productCategories", "navHome")}</Link>
        </div>
        <div className="text-[#77878F]">{">"}</div>
        <div className=" flex justify-center items-center">
          <p className=" text-[#FFC633] font-poppins text-[14px] font-semibold">
            {subCatName ? subCatName : catName ? catName : main}
          </p>
        </div>
      </div>
      {/* title */}
      <div className=" flex flex-col justify-center items-center gap-y-3">
        {activeCategory ? (
          <div className="text-[36px] font-poppins font-semibold flex gap-x-2 text-[#FFC633]">
            {activeCategory?.name}
          </div>
        ) : (
          <p className="text-[36px] font-poppins font-semibold flex gap-x-2">
            <span className="text-[#FFC633] text-center">
              {/* {subCatName && subCatName.split(" ")[0]} */}
              {subCatName ? subCatName : catName}
            </span>{" "}
            {/* <span className="text-primary-color flex gap-x-2"> */}
            {/* <p>{subCatName && subCatName.split(" ")[1]}</p>
              <p>{subCatName && subCatName.split(" ")[2]}</p> */}
            {/* </span> */}
          </p>
        )}
        <p className=" text-center w-8/12 text-black font-poppins font-[500] text-[12px]">
          {t("productCategories", "text")}
        </p>
      </div>
      {/* content */}
      <div className=" w-full sm:w-10/12 lg:w-full 2xl:w-10/12 mx-auto mt-8  flex flex-col lg:flex-row px-5 ">
        {/* sidebar */}
        <div className=" flex-1 min-w-[350px]  p-4">
          {/* categories */}
          <div className=" flex flex-col gap-y-4 border-b py-5">
            <h2 className=" font-poppins font-[500] text-[19px] text-[#191C1F]">
              {t("productCategories", "categories")}
            </h2>
            <div className="">
              {categories?.map((category: any, index: number) => (
                <label
                  key={index}
                  className="flex items-center gap-3 mb-2 cursor-pointer"
                >
                  <input
                    type="radio"
                    name="category"
                    value={category?.name}
                    key={category?.id}
                    className="cursor-pointer border-2 border-gray-400 checked:bg-yellow-color w-[20px] h-[20px]"
                    onChange={() => handleChangeCategory(category)}
                  />
                  <span
                    className={`text-[14px] font-[500] font-poppins ${activeCategory?.name === category?.name
                        ? "text-[#191C1F] font-semibold"
                        : "text-[#475156]"
                      }`}
                  >
                    {category?.name}
                  </span>
                </label>
              ))}
            </div>
          </div>
          {/* price */}
          {language == "tr" && (
            <div className=" py-5 flex flex-col gap-y-4 border-b">
              <h2 className=" font-poppins font-[500] text-[19px] text-[#191C1F]">
                {t("productCategories", "price")}
              </h2>
              {/* range */}
              <div className="w-full">
                {/* Labels */}
                <div className="flex justify-between text-[11px] font-normal mb-1">
                  <div>0</div>
                  <div>2500</div>
                  <div>5000</div>
                </div>

                {/* Progress Bar */}
                <div className="relative w-full bg-gray-200 h-[4px] rounded-full overflow-hidden">
                  <div
                    style={{
                      width: `${progress}%`,
                      left: `${offset}%`,
                    }}
                    className="absolute h-[4px] bg-yellow-color rounded-full transition-all duration-300 ease-in-out"
                  ></div>
                </div>

                {/* Inputs */}
                <div className="flex w-full gap-x-3 mt-3">
                  <input
                    type="text"
                    className="border w-1/2 border-[#E4E7E9] rounded-[3px] p-2"
                    placeholder={t("productCategories", "min")}
                    value={minPrice}
                    onChange={handleMinPriceChange}
                  />
                  <input
                    type="text"
                    className="border w-1/2 border-[#E4E7E9] rounded-[3px] p-2"
                    placeholder={t("productCategories", "max")}
                    value={maxPrice}
                    onChange={handleMaxPriceChange}
                  />
                </div>

                {/* Confirm Button */}
                <div className="flex justify-center">
                  <button
                    onClick={handleApply}
                    className="bg-primary-color text-white py-2 text-[11px] mt-2 px-4 active:scale-90 transition-transform rounded font-semibold hover:bg-opacity-90"
                  >
                    {t("productCategories", "applyButton")}
                  </button>
                </div>
              </div>
              {/* prices */}
              {language === "tr" ? (
                <div className="">
                  {prices?.map((price: any, index: number) => (
                    <label
                      key={index}
                      className="flex items-center gap-3 mb-2 cursor-pointer"
                    >
                      <input
                        type="radio"
                        name="category"
                        value={price?.value}
                        className="cursor-pointer border-2 border-gray-400 checked:bg-yellow-color w-[20px] h-[20px]"
                        onChange={() => handlePriceChange(price)}
                      />
                      <span
                        className={`text-[14px] font-[500] font-poppins ${activePrice?.value === price?.value
                            ? "text-[#191C1F] font-semibold"
                            : "text-[#475156]"
                          }`}
                      >
                        {price?.value}
                      </span>
                    </label>
                  ))}
                </div>
              ) : (
                <></>
              )}
            </div>
          )}
        </div>
        {/* products */}
        {loading ? (
          <div className="w-full h-1/2 flex justify-center items-center">
            <Spinner />
          </div>
        ) : categoryProducts?.length < 1 ? (
          <div className="flex-[4] flex justify-center items-center p-4 gap-y-3 flex-col">
            <BsSnow size={40} className="text-yellow-color" />
            <p className="text-[#475156] text-[14px]">
              {t("productCategories", "filterErr")}
            </p>
          </div>
        ) : filteredProducts?.length === 0 &&
          (activePrice || (minPrice && maxPrice)) ? (
          <div className="flex-[4] flex justify-center items-center p-4 gap-y-3 flex-col">
            <BsSnow size={40} className="text-yellow-color" />
            <p className="text-[#475156] text-[14px] text-center">
              {minPrice && maxPrice
                ? `${minPrice}TL - ${maxPrice} ${t(
                  "productCategories",
                  "noProduct"
                )}`
                : `${activePrice?.min} - ${activePrice?.max === Infinity ? "" : activePrice?.max
                } ${t("productCategories", "noProduct")}`}
            </p>
            <button
              onClick={() => {
                setFilteredProducts([]);
                setActivePrice(null);
                setMinPrice("");
                setMaxPrice("");
              }}
              className="mt-2 px-4 py-2 bg-yellow-color text-white rounded-md hover:bg-yellow-600 transition-colors"
            >
              {t("productCategories", "clearButton")}
            </button>
          </div>
        ) : (
          <div className="flex-[4] grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4 justify-items-center p-4 gap-5 mb-52">
            {(filteredProducts?.length > 0
              ? filteredProducts
              : categoryProducts
            )?.map((product: any) => (
              <ProductCart
                key={product?.id}
                product={product}
                type={'pcat'}
                userBusinessPackage={userBusinessPackage}
              />
            ))}
          </div>
        )}
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default ProductCategories;
